import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

import { RevealList } from "../motion/Reveal";
import { useT } from "../../i18n";
import { SERVICES } from "../../content/services";

// The home page's seven services. A directory, not a card grid: index, title,
// tagline and an arrow on one line, hairline between rows.
//
// Card grids force every service into the same visual weight and turn a page
// into a scrapyard. A list keeps them scannable and lets the taglines breathe.

export default function ServiceDirectory() {
  const { t } = useT();

  return (
    <RevealList
      className="rows flex flex-col"
      items={SERVICES.map((s, i) => ({ key: s.slug, slug: s.slug, i }))}
      step={45}
    >
      {({ slug, i }) => (
        <Link
          to={`/${slug}`}
          className="row-link row-t group flex flex-col gap-2 py-5 sm:flex-row sm:items-center sm:gap-7"
        >
          <span className="w-[34px] shrink-0 font-mono text-[13px] text-fg-muted tabular-nums">
            {String(i + 1).padStart(2, "0")}
          </span>
          <span className="row-title font-heading text-[18px] font-semibold leading-[1.35] tracking-[-0.4px] text-fg transition-colors duration-200 sm:w-[280px] sm:shrink-0 sm:text-[19px]">
            {t(`services.${slug}.title`)}
          </span>
          <span className="min-w-0 flex-1 font-body text-[15px] leading-[1.6] text-fg-muted">
            {t(`services.${slug}.tagline`)}
          </span>
          <ArrowUpRight
            size={17}
            strokeWidth={2}
            className="row-arrow hidden shrink-0 text-fg-muted sm:block"
            aria-hidden="true"
          />
        </Link>
      )}
    </RevealList>
  );
}
